import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Container, Row, Col, Button, Card, CardBody } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import ServerTable from "../../../lib/ServerTable";
import getUserColums from "./columns/UserColumns";
import { useAuth, useApiDelete } from "../../../hooks";
import { ConfirmModal, SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import filterIcon from "../../../common/images/filter.png";
import { UserDetailModal } from "./UserDetailModal";
import AddUser from "./UserAdd";
import EditUser from "./UserEdit";

const formInitailData = {
    userStatus: null,
  };

export default function User() {

   const navigate = useNavigate();
   const roleKeyVal = localStorage.getItem("roleKey");
   const entityId = localStorage.getItem("entityId");
   let activeRole = 'bunk_incharge';
   if(roleKeyVal === 'bunk_incharge' && entityId != "") {
        if(entityId) {
          activeRole = 'employee';
        } else {
          navigate('/');
        }
   }

  const [formData, setFormData] = useState(formInitailData);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showUserAdd, setShowUserAdd] = useState(false);
  const [rowEditData, setRowEditData] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [showFilder, setShowFilder] = useState(false);
  const [roleKey, setRoleKey] = useState(activeRole);
  const [rowData, setRowData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState('');
  const [customSearch, setCustomSearch] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [customerror, setCustomerror] = useState('');
  const [searchObjVal, setSearchObjVal] = useState('');
  const [tableKey, setTableKey] = useState(0);
  const { authToken } = useAuth();
  const { deleteData, loading, error } = useApiDelete('users',authToken);

  useEffect(() => {
        const searchObj = {};
        let filterTxt = 'roleKey|'+roleKey;
        if(roleKeyVal === 'bunk_incharge') {
            filterTxt = filterTxt+'&entityId|'+entityId;
        }
        if(formData?.userStatus?.value !== undefined && formData?.userStatus?.value != "") {
          let isActiveVal = (formData?.cameraStatus?.value == 'active') ? true : false;
          filterTxt = filterTxt+'&isActive|'+isActiveVal;
        }
  
        if(filterTxt != "") {
          searchObj.filter = filterTxt;
        }
  
        setSearchObjVal(searchObj);
        setTableKey(prev => prev + 1);
  }, [
    formData?.userStatus?.value,
    roleKey
  ]);

  const handleDelete = (roleId) => {
        setShowConfirm(true);
        setSelectedRowId(roleId);
  };

  const handleViewDetail = (rowDetails) => {
        setRowData(rowDetails);
        setShowDetails(true);
  };

  const handleConfirm = async () => {
    let payloadObj = { id: selectedRowId };
    let payload = JSON.stringify(payloadObj);
    const { result, error } = await deleteData(payload);
    
    if(error) {
      setCustomerror(error);
    } else {
      setIsDeleted(true);
      setTableKey(prevKey => prevKey + 1);
    }

    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleDetailCancel = () => {
    setShowDetails(false);
    setRowData([]);
  };

  const handleUserAddCancel = () => {
        setShowUserAdd(false);
  };

  const handleUserEditCancel = () => {
        setShowEditForm(false);
  };

  const handleSearchChange = (e) => {
    setCustomSearch(e.target.value);
  };

  const handleEditUser = (rowDetails) => {
      setRowEditData(rowDetails);
      setShowEditForm(true);
  };


  const columns = getUserColums(handleDelete, handleViewDetail, handleEditUser, roleKeyVal, roleKey);

  const handleChange = (selectedOption, actionMeta) => {
    setFormData(prev => ({
      ...prev,
      [actionMeta.name]: selectedOption
    }));
  };

  const userStatusOptions = [
    { value: "", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const handleAddUser = () => {
        setShowUserAdd(true);
  }

  const handleAct = () => {
        setShowUserAdd(false);
        setShowEditForm(false);
        setTableKey(prev => prev + 1);
  }

  return (<div className="user-management-page">
          <Container fluid>
            <div className='page-title-main'>
              <h5 className='page-title'>{(roleKeyVal === 'super_admin') ? "User" : "Employee" } Management</h5>
              <p className='page-info'>Manage and monitor bunk admins.</p>
            </div> 
            <div className='page-content-main'>
              {isDeleted && <SuccessToolbar message="🎉 User have been deleted successfully." />}
              {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
              
              {(roleKeyVal === 'super_admin') && <div className='filter-tab-main'>
                    <div className='filter-tab-inner'>
                        <div className={(roleKey === 'bunk_incharge')?'filter-tab1 active':'filter-tab1'}>
                                <Button variant="secondary custom-tab1-btncls" onClick={() => setRoleKey('bunk_incharge')} type="button">
                                  Admin Management
                                </Button>
                        </div>
                        <div className={(roleKey === 'employee')?'filter-tab2 active':'filter-tab2'}>
                                <Button variant="secondary custom-tab2-btncls" onClick={() => setRoleKey('employee')} type="button">
                                  Employee Management
                                </Button>
                        </div>
                    </div>
              </div>}

              <div className='filter-action-main'>
                    <Row className="mb-2">
                        {(roleKeyVal === 'super_admin')?<Col xs={12} sm={12} md={12}>
                            <div className='input-filter-action'>
                                <input type="text" id="customSearch" name='customSearch' placeholder="Search by user name, contact & email" value={customSearch} onChange={handleSearchChange} />
                            </div>
                        </Col>:<>
                        <Col xs={12} sm={10} md={10}>
                            <div className='input-filter-action'>
                                <input type="text" id="customSearch" name='customSearch' placeholder="Search by user name, contact & email" value={customSearch} onChange={handleSearchChange} />
                            </div>
                        </Col>
                        <Col xs={12} sm={2} md={2} className='apply-mgtp-mbl'>
                            <div className='create-record-action text-end'>
                                <Button type="button" className="btn btn-primary add-btn-flteract" onClick={() => handleAddUser()}>
                                  <FaPlus /> Add Employee
                                </Button>
                            </div>
                        </Col>
                        </>}
                        {/*<Col xs={6} sm={6} md={2} className='apply-mgtp-mbl'>
                            <div className='create-record-action filter-action-slt'>
                                <Select
                                  name="userStatus"
                                  options={userStatusOptions}
                                  value={formData.userStatus}
                                  onChange={handleChange}
                                  placeholder={"Select Status"}
                                  className='custom-react-sltbx'
                                  classNamePrefix="custom-react-sltbx"
                                />
                            </div>
                        </Col>*/}
                    </Row>
              </div>

              <Row>
                <Col xs="12">
                      <div className='tablelist-maindiv'>
                          <ServerTable
                            key={tableKey}
                            apiUrlTxt="users"
                            columns={columns}
                            customParams={searchObjVal}
                            showSearch={false}
                            showAddBtn={false}
                            addBtn={{ label: '', url: `` }}
                            srlNumbr={false}
                            customSearch={true}
                            customSearchTxt={customSearch}
                          />
                      </div>
                
                </Col>
              </Row>
            </div>   

            <UserDetailModal
              show={showDetails}
              onHide={handleDetailCancel}
              resultdata={rowData}
              roleKeyVal={roleKeyVal}
              roleKey={roleKey}
            />

            <AddUser
              show={showUserAdd}
              onHide={handleUserAddCancel}
              handleAct={handleAct}
            />

            <EditUser
              show={showEditForm}
              onHide={handleUserEditCancel}
              userDetails={rowEditData}
              handleAct={handleAct}
            />

             <ConfirmModal
                show={showConfirm}
                onHide={handleCancel}
                onConfirm={handleConfirm}
                title={<span className='confirm-mdltitle-iconmain'><i className="bx bx-trash"></i></span>}
                message="Are you sure you want to delete this user?"
                btntxt="Delete"
              />

          </Container>
        </div>);
}
